import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface RefundApprovalItem {
  id: string;
  refundNo: string;
  refundType: 'PARTIAL' | 'FULL';
  namerefund: string;
  bankName: string | null;
  account_number: string;
  amount: number | string;
  reason: string;
  attachmentPath: string | null;
  status: 'SUPERVISOR_REVIEW';
  requestedAt: string | null;
  createdAt: string;
  requestedBy: { firstName: string; lastName: string };
  booking: {
    id: string;
    bookingNo: string;
    bookingType: 'JOIN_TOUR' | 'GROUP_TOUR';
    tourName: string;
    tourCode: string | null;
    country: string;
    departureDate: string;
    returnDate: string | null;
    pax: number;
    totalAmount: number | string;
    booking_customer: { name: string };
  };
}

@Injectable({ providedIn: 'root' })
export class RefundApprovalService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/refunds/supervisor-review`;

  async getPending(): Promise<RefundApprovalItem[]> {
    const response = await firstValueFrom(
      this.http.get<{ refunds: RefundApprovalItem[] }>(this.apiUrl, {
        withCredentials: true,
      }),
    );
    return response.refunds;
  }

  async approve(id: string): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/approve`, {}, { withCredentials: true }),
    );
  }

  async reject(id: string): Promise<void> {
    await firstValueFrom(
      this.http.patch(`${this.apiUrl}/${id}/reject`, {}, { withCredentials: true }),
    );
  }

  resolveFileUrl(fileUrl: string): string {
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    if (/^https?:\/\//i.test(environment.apiUrl)) {
      return `${new URL(environment.apiUrl).origin}${fileUrl}`;
    }
    return fileUrl;
  }
}
